import { AddEditJobRequest } from '../../domain/requests/jobs/add-edit-job.request';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { JobsRepository } from "../../repositories";
import { EditJobRequest } from '../../domain/requests/jobs/edit-job.request';

@Injectable({ providedIn: 'root' })
export class UpdateJobUsecase implements UseCase<EditJobRequest, boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: EditJobRequest): Observable<boolean> {
    return this.jobRepository.updateJob(params);
  }

}
